import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { LuArrowLeft } from "react-icons/lu";
import { notificationViewActions } from "../../store/services/notificationViewSlice";

const customStyles = {
  content: {
    position: "static",
    border: "none",
    borderRadius: "12px",
    padding: "0",
    maxWidth: "90vw",
    maxHeight: "90vh",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
};

Modal.setAppElement(document.getElementById("root"));

export default function NotificationView() {
  const data = useSelector((state) => state.notification_view.data);
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.notification_view.isOpen);

  function closeModal() {
    dispatch(notificationViewActions.closeModal());
  }

  const handleCancel = () => {
    dispatch(notificationViewActions.closeModal());
  };

  const renderImages = () => {
    const imagePaths = Array.isArray(data.image_path)
      ? data.image_path
      : [data.image_path];

    return (
      <div
        className={`grid ${imagePaths.length > 1
          ? "grid-cols-2 gap-4 max-h-[400px] overflow-y-auto"
          : "grid-cols-1"
          } justify-center items-center`}
      >
        {imagePaths.map(
          (image, index) =>
            image && (
              <div key={index} className="flex justify-center">
                <img
                  src={`${process.env.REACT_APP_BACKEND_HOST}/api/${image}`}
                  alt="Notification"
                  className="rounded-lg w-full max-h-[250px] object-cover shadow-md"
                />
              </div>
            )
        )}
      </div>
    );
  };

  console.log({ data })

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Notification Details"
    >
      <div className="bg-white p-6 md:p-8 w-[480px] rounded-xl shadow-lg">
        <div className="flex flex-col gap-4">
          <div className="text-lg text-center font-semibold">Detajet e njoftimit</div>
          <hr/>
          {data.image_path && (
            <img src={`${process.env.REACT_APP_BACKEND_HOST}/api/${data.image_path}`} alt="notification_image" className="h-48 object-cover rounded-lg" />
          )}
          <div className="text-xl font-medium">{data.title}</div>
          {/* <hr className="my-2" /> */}
          <div className="text-sm">
            <div className="prose" dangerouslySetInnerHTML={{ __html: data.body }}></div>
            <hr className="my-2" />
            <div className="flex items-center justify-between font-light text-gray-400">
              <div className="text-sm">{data.total_users} qytetarë kanë marrë këtë njoftim</div>
              <div className="">{new Date(data.received_at).toLocaleString("en-GB", { timeZone: "Europe/Tirane" })}</div>
            </div>
          </div>
        </div>
        {/* <div className="flex justify-between mt-6">
          <button
            className="flex items-center gap-2 p-2 text-sm px-6 rounded-md cursor-pointer border border-gray-300 hover:bg-gray-100 transition-all"
            onClick={handleCancel}
          >
            <LuArrowLeft size={18} />
            <span>Back</span>
          </button>
        </div> */}
      </div>
    </Modal>
  );
}
